'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _plugin = require('@swup/plugin');

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LivewirePlugin = function (_Plugin) {
	_inherits(LivewirePlugin, _Plugin);

	function LivewirePlugin() {
		_classCallCheck(this, LivewirePlugin);

		var _this = _possibleConstructorReturn(this, (LivewirePlugin.__proto__ || Object.getPrototypeOf(LivewirePlugin)).call(this));

		_this.name = 'LivewirePlugin';


		if (typeof window.Livewire === 'undefined') {
			throw 'window.Livewire is undefined. Make sure to include @livewireScripts before this script';
		}

		_this.livewireComponents = [];
		return _this;
	}

	_createClass(LivewirePlugin, [{
		key: 'mount',
		value: function mount() {
			var _this2 = this;

			this.swup.on('clickLink', function () {
				return _this2.cacheLivewireComponents();
			});
			this.swup.on('contentReplaced', function () {
				return _this2.refreshLivewireComponents();
			});
		}
	}, {
		key: 'unmount',
		value: function unmount() {
			// this is executed when swup with plugin is disabled
			// you can use this.swup here to access swup instance
		}
	}, {
		key: 'cacheLivewireComponents',
		value: function cacheLivewireComponents() {
			// Save Livewire components to refresh later
			this.livewireComponents[window.location.pathname] = document.querySelectorAll('[wire\\:id]');

			// Pages with Livewire components should not be cached
			if (this.livewireComponents[window.location.pathname].length) {
				this.swup.cache.remove(window.location.pathname);
			}
		}
	}, {
		key: 'refreshLivewireComponents',
		value: function refreshLivewireComponents() {
			// Refresh any previously saved Livewire Components
			if (this.livewireComponents[window.location.pathname]) {
				this.livewireComponents[window.location.pathname].forEach(function (el) {
					var component = el.__livewire;
					var dataObject = {
						fingerprint: component.fingerprint,
						serverMemo: component.serverMemo,
						effects: component.effects
					};
					el.setAttribute('wire:initial-data', JSON.stringify(dataObject));
				});
			}

			// Aleays restart Livewire
			window.Livewire.restart();
		}
	}]);

	return LivewirePlugin;
}(_plugin2.default);

exports.default = LivewirePlugin;